module.exports = __webpack_public_path__ + "static/media/pagination-next.42728d5d.svg";